// extracted by mini-css-extract-plugin
export default {"buttonGroup":"genericScreenDefinitionRowDetails_buttonGroup__txh4R"};